import { formatHtml } from "@trumpf/ux.common-storybook";
import { exampleSlot, exampleSlotWithFooter, Template } from "./page.templates";

export default {
    title: "Salesforce/Components/Page",
    component: "ux-iws-sf-page",
    render: Template.bind({}),
    parameters: {
        layout: "fullscreen",
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    argTypes: {
        variant: {
            control: { type: "select" },
            options: ["center", "center-blue"],
        },
        fullHeight: {
            control: { type: "boolean" },
        },
        className: {
            table: {
                disable: true,
            },
        },
        _slot: {
            table: {
                disable: true,
            },
        },
    },
    args: {
        className: "ux-t-container-full",
        variant: "center",
        fullHeight: false,
        _slot: exampleSlot,
    },
};

export const Default = {};

export const WithFooter = {
    args: {
        variant: "center",
        _slot: exampleSlotWithFooter,
    },
};

export const BlueBackground = {
    args: {
        variant: "center-blue",
        _slot: exampleSlotWithFooter,
    },
};

export const SmallContent = {
    args: {
        variant: "center-blue",
        _slot: exampleSlotWithFooter.replace(
            `<ux-iws-sf-page-content>`,
            `<ux-iws-sf-page-content size="s">`
        ),
    },
};

export const LargeContent = {
    args: {
        variant: "center-blue",
        _slot: exampleSlotWithFooter.replace(
            `<ux-iws-sf-page-content>`,
            `<ux-iws-sf-page-content size="l">`
        ),
    },
};

export const FullHeight = {
    args: {
        variant: "center-blue",
        fullHeight: true,
        _slot: exampleSlotWithFooter,
    },
};
